import { AppRoutes } from "../constants/routes";

const isAmazonAuthRedirectCall = (
  searchParams: URLSearchParams | undefined
): [boolean, string | undefined] => {
  const defaultValueToBeReturned: [boolean, string | undefined] = [
    false,
    undefined,
  ];
  if (!searchParams) {
    return defaultValueToBeReturned;
  }

  if (
    searchParams.get("amazon_callback_uri") &&
    searchParams.get("amazon_state")
  ) {
    return [
      true,
      `${AppRoutes.Private.Settings.INTEGRATIONS_ECOMMERCE_CONNECT}/amazonsellingpartner`,
    ];
  }
  return defaultValueToBeReturned;
};

const checkAuthRedirectCall = (searchParams: URLSearchParams | undefined) => {
  const redirectParams = isAmazonAuthRedirectCall(searchParams);
  if (redirectParams[0]) {
    return redirectParams;
  }
  // check for otgher redirections ni the furture
  return redirectParams;
};

export const useRedirectionCheck = () => {
  return (params?: URLSearchParams) => checkAuthRedirectCall(params);
};
